import React, { useEffect, useState } from 'react';
import SeoHead from '../components/SeoHead';
import { TfiMicrosoftAlt } from "react-icons/tfi";
import { PiUserSoundLight } from "react-icons/pi";
import { GoDatabase, GoPerson } from "react-icons/go";
import { MdOutlineSegment } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";
import { IoMailOutline, IoShieldOutline } from "react-icons/io5";
import reciveEmailImg from '../assets/recive_email.png';
import agentResponseEmailImg from '../assets/agent_response_email.png';
import emailAgentVideo from '../assets/videos/Email Agent.mp4';

const pageStyle = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #fff9f6 0%, #ffffff 50%, #fef3ee 100%)',
  color: '#1f1f1f',
  fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
};

const sectionStyle = {
  maxWidth: '85%',
  margin: '0 auto',
  padding: '4rem 1.5rem',
};

const heroSectionStyle = {
  width: '100%',
  padding: '4rem 0',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const heroInnerStyle = {
  maxWidth: '85%',
  margin: '0 auto',
  padding: '0 1.5rem',
  display: 'flex',
  justifyContent: 'center',
};

const heroStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: '1.5rem',
};

const badgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
  padding: '0.4rem 0.9rem',
  borderRadius: '999px',
  background: '#FFF0EC',
  color: '#C03626',
  fontWeight: 700,
  fontSize: '0.9rem',
};

const heroTitleStyle = {
  display: 'flex',
  justifyContent: 'center',
  fontSize: '2.8rem',
  lineHeight: 1.15,
  margin: '1rem 0 1.25rem',
  color: '#1f1f1f',
  fontWeight: 800,
};

const heroTextStyle = {
  fontSize: '1.15rem',
  lineHeight: 1.7,
  color: '#353535',
  maxWidth: '38rem',
  margin: '0 auto',
};

const ctaRowStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1rem',
  marginTop: '1.75rem',
  justifyContent: 'center',
};

const primaryCtaStyle = {
  background: 'linear-gradient(135deg, #C03626, #FF6F61)',
  color: '#ffffff',
  border: 'none',
  borderRadius: '12px',
  padding: '1rem 1.6rem',
  fontWeight: 700,
  fontSize: '1rem',
  cursor: 'pointer',
  boxShadow: '0 14px 30px rgba(192, 54, 38, 0.25)',
};

const mailCtaStyle = {
  ...primaryCtaStyle,
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.6rem',
  textDecoration: 'none',
};

const secondaryCtaStyle = {
  background: '#ffffff',
  color: '#C03626',
  border: '1px solid #C03626',
  borderRadius: '12px',
  padding: '1rem 1.6rem',
  fontWeight: 700,
  fontSize: '1rem',
  cursor: 'pointer',
};

const sectionHeaderStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.4rem',
  marginBottom: '1.5rem',
};

const eyebrowStyle = {
  textTransform: 'uppercase',
  letterSpacing: '0.18em',
  fontWeight: 700,
  color: '#C03626',
  fontSize: '0.85rem',
};

const problemRowStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: '2rem',
  alignItems: 'flex-start',
  background: '#fff',
  borderRadius: '18px',
  padding: '2rem',
  border: '1px solid #f1d1c9',
  boxShadow: '0 14px 34px rgba(0, 0, 0, 0.04)',
};

const problemLeftStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
};

const problemRightStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
  gap: '0.65rem 1.2rem',
};

const checklistItemStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.6rem',
  fontSize: '1rem',
  lineHeight: 1.5,
  color: '#2d1f1b',
};

const checkIconStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  background: '#FFF0EC',
  color: '#C03626',
  fontWeight: 800,
  fontSize: '0.95rem',
  marginTop: '0.1rem',
};

const flowSectionStyle = {
  width: '90%',
  padding: '2rem 0 1.5rem',
};

const flowHeaderStyle = {
  textAlign: 'center',
  marginBottom: '2rem',
};

const flowRowStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
  gap: '1.2rem',
  alignItems: 'stretch',
  width: '100%',
  maxWidth: '1100px',
  margin: '0 auto',
  padding: '0 1.5rem',
};

const flowCardStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  minHeight: '100%',
  alignItems: 'center',
  textAlign: 'center',
};

const flowImageStyle = {
  width: '90%',
  minHeight: '180px',
  background: '#ffffff',
  borderRadius: '10px',
  display: 'grid',
  placeItems: 'center',
  color: '#C03626',
  fontWeight: 700,
};

const flowImageImg = {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  borderRadius: '10px',
};

const flowTitleStyle = {
  fontWeight: 800,
  fontSize: '1.05rem',
  color: '#1f1f1f',
  margin: '0.35rem 0 0.1rem',
};

const flowTextStyle = {
  fontSize: '0.98rem',
  lineHeight: 1.55,
  color: '#373737',
  maxWidth: '360px',
};

const howGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
  gap: '1.5rem',
};

const cardStyle = {
  background: '#ffffff',
  borderRadius: '14px',
  padding: '1.4rem',
  border: '1px solid #f1d1c9',
  boxShadow: '0 14px 34px rgba(0, 0, 0, 0.05)',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
};

const iconDotStyle = {
  width: '46px',
  height: '46px',
  borderRadius: '12px',
  background: '#FFF0EC',
  display: 'grid',
  placeItems: 'center',
  color: '#C03626',
  fontWeight: 800,
  fontSize: '1.3rem',
};

const emailFeatures = [
  {
    title: "Fælles tone of voice",
    desc: "Holder brand, ansvarsfraskrivelser og politikker på tværs af teams.",
    Icon: PiUserSoundLight,
  },
  {
    title: "Dataindsamling",
    desc: "Fanger indsigter fra henvendelserne, så vidensbasen bliver bedre over tid.",
    Icon: GoDatabase,
  },
  {
    title: "Human-in-the-loop",
    desc: "Ingen automatiske udsendelser – mennesket godkender altid.",
    Icon: GoPerson,
  },
  {
    title: "Segmentsmart",
    desc: "Tilpas til kundeservice, salg, HR eller andre funktioner.",
    Icon: MdOutlineSegment,
  },
  {
    title: "Kvalitet over hastighed",
    desc: "Prioriterer klarhed og korrekthed før send.",
    Icon: IoIosSearch,
  },
  {
    title: "Sikkerhed & compliance",
    desc: "Kører i Microsoft-miljøet med fuld sporbarhed.",
    Icon: IoShieldOutline,
  },
];

const placeholderFrame = {
  width: '100%',
  minHeight: '220px',
  background: '#ffffff',
  borderRadius: '18px',
  border: '1px dashed #f1d1c9',
  display: 'grid',
  placeItems: 'center',
  color: '#9c2c1f',
  fontWeight: 700,
  fontSize: '1rem',
};

const footerStripStyle = {
  marginTop: '3rem',
  padding: '1.5rem 1.4rem',
  borderRadius: '12px',
  border: '1px solid #f1d1c9',
  background: '#fff9f6',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1rem',
  alignItems: 'center',
  justifyContent: 'space-between',
};

const videoFrameStyle = {
  position: 'relative',
  width: '100%',
  maxWidth: '960px',
  margin: '0 auto',
  paddingTop: '56.25%',
  overflow: 'hidden',
  display: 'block',
};

const videoStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  border: 'none',
};

const Emailagenten = () => {
  const [isWideLayout, setIsWideLayout] = useState(typeof window !== 'undefined' ? window.innerWidth >= 1000 : false);
  const scrollToDemo = () => {
    const demoSection = document.getElementById('emailagent-demo');
    if (demoSection) {
      demoSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(() => {
    const handleResize = () => setIsWideLayout(window.innerWidth >= 1000);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={pageStyle}>
      <SeoHead
        title="Emailagenten | AI-assistent til indbakken"
        description="Emailagenten skriver svarudkast til indgående e-mails i kundeservice, salg og HR. Ensartet tone of voice, kvalitetssikring og menneskelig godkendelse."
        canonicalPath="/losninger/emailagenten"
      />

      {/* HERO */}
      <section style={heroSectionStyle}>
        <div style={heroInnerStyle}>
          <div style={heroStyle}>
            <div>
              <div style={badgeStyle}>📧 Emailagenten</div>

              <h1 style={heroTitleStyle}>
                Svarudkast på sekunder.<br />
                Styrket kundeoplevelse på tværs af teams.
              </h1>

              <p style={heroTextStyle}>
                Emailagenten skriver udkast til alle indgående e-mails – fra kundeservice til salg og HR.
                Hurtigere svar, konsistente formuleringer og én fælles vidensbase, der holder tonen på plads.
              </p>

              <div style={{ marginTop: '1.2rem', display: 'inline-flex', alignItems: 'center', gap: 8, color: '#2D1F1B', fontWeight: 600 }}>
                <TfiMicrosoftAlt size={20} color="#C03626" />
                <span>Integreret i jeres Microsoft-miljø</span>
              </div>

              <div style={ctaRowStyle}>
                <button type="button" style={primaryCtaStyle} onClick={scrollToDemo}>Se hvordan det virker</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PROBLEM */}
      <section style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <span style={eyebrowStyle}>Problemet</span>
          <h2 style={{ fontSize: '2.1rem', margin: 0 }}>Svarkøer, inkonsistent tone og manuelle copy/paste-runder.</h2>
        </div>

        <div style={problemRowStyle}>
          <div style={problemLeftStyle}>
            <h3 style={{ margin: 0, fontSize: '1.6rem', lineHeight: 1.3, color: '#1f1f1f' }}>
              Mindre ventetid for kunderne, mere tid til det menneskelige.
            </h3>
            <p style={{ margin: '0.75rem 0 0', fontSize: '1.05rem', lineHeight: 1.65, color: '#3b2f2b' }}>
              Én agent der kan bruges i kundeservice, salg og alle teams med en travl indbakke.
              Den foreslår svar, holder tone of voice og trækker på samme vidensbase – så I leverer rolig, ensartet service.
            </p>
          </div>

          <div style={problemRightStyle}>
            {[
              "Holder tone, ansvarsfraskrivelser og politikker på tværs af teams.",
              "Reducerer kopi/indsæt mellem vidensartikler og e-mails.",
              "Én fælles vidensbase – altid opdateret.",
              "Klar til flere segmenter: support, salg, HR m.fl.",
              "Mennesket godkender – agenten forbereder.",
            ].map((text, idx) => (
              <div key={idx} style={checklistItemStyle}>
                <span style={checkIconStyle}>✓</span>
                <span>{text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FLOW */}
      <section style={flowSectionStyle}>
        <div style={flowHeaderStyle}>
          <span style={eyebrowStyle}>Fra mail til svarudkast</span>
          <h2 style={{ fontSize: '2rem', margin: '0.35rem 0 0.5rem' }}>Automatiseret. Men aldrig ukontrolleret.</h2>
          <p style={{ fontSize: '1.05rem', color: '#404040', margin: 0 }}>
            Forbindes til jeres indbakke, foreslår udkast og holder jeres tone og politikker intakte.
          </p>
        </div>

        <div
          style={{
            ...flowRowStyle,
            gridTemplateColumns: isWideLayout ? 'repeat(2, minmax(0, 1fr))' : '1fr',
            width: isWideLayout ? '90%' : '100%',
            maxWidth: isWideLayout ? '90vw' : '1100px',
          }}
        >
          <div style={flowCardStyle}>
            <div style={flowImageStyle}>
              <img src={reciveEmailImg} alt="Modtag i indbakken" style={flowImageImg} />
            </div>
            <div style={flowTitleStyle}>Tilsluttet jeres indbakke</div>
            <div style={flowTextStyle}>Agenten overvåger den valgte mappe/gruppe i Microsoft 365 og henter nye e-mails med kontekst og historik.</div>
          </div>
          <div style={flowCardStyle}>
            <div style={flowImageStyle}>
              <img src={agentResponseEmailImg} alt="Godkend & send" style={flowImageImg} />
            </div>
            <div style={flowTitleStyle}>Læs, justér, udsend</div>
            <div style={flowTextStyle}>Agenten gemmer et svarudkast som kladde, så man nemt kan trykke Rediger, lægge nødvendige ændringer ind og sende mailen afsted.</div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <span style={eyebrowStyle}>Features</span>
          <h2 style={{ fontSize: '2rem', margin: 0 }}>Bygget til teams med travle indbakker.</h2>
        </div>

        <div style={howGridStyle}>
          {emailFeatures.map(({ title, desc, Icon }) => (
            <div key={title} style={cardStyle}>
              <div style={iconDotStyle}>
                <Icon size={22} />
              </div>
              <h3 style={{ margin: 0 }}>{title}</h3>
              <p style={{ margin: 0, lineHeight: 1.6 }}>{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* VIDEO */}
      <section id="emailagent-demo" style={{ ...sectionStyle, paddingBottom: '3rem' }}>
        <div style={{ ...sectionHeaderStyle, alignItems: 'center', textAlign: 'center' }}>
          <span style={eyebrowStyle}>Demo</span>
          <h2 style={{ fontSize: '2rem', margin: 0 }}>Se hvordan Emailagenten håndterer en indbakke i praksis.</h2>
        </div>
        <div style={videoFrameStyle}>
          <video
            style={videoStyle}
            controls
            playsInline
            preload="metadata"
          >
            <source src={emailAgentVideo} type="video/mp4" />
            Din browser understøtter ikke videoafspilning.
          </video>
        </div>
      </section>

      {/* CONTACT CTA */}
      <section style={{ ...sectionStyle, paddingTop: '1.5rem', paddingBottom: '6rem' }}>
        <div style={footerStripStyle}>
          <div style={{ fontWeight: 600, color: '#2D1F1B' }}>
            Ønsker du at se hvordan et forløb ser ud? Send os en email.
          </div>
          <a href="mailto:cm@aice.dk" style={mailCtaStyle}>
            <IoMailOutline size={20} />
            Send en mail
          </a>
        </div>
      </section>

    </div>
  );
};

export default Emailagenten;
